<h1 style="text-align: center;">CPSID24 - Cryptography, Protocols and Security in Digital Identity 2024</h1>
<h2>Abstract</h2>
<p>
    The seminar dives into the two main current identity standards, EUDI-ARF and
    W3C-DID/W3C-VC and describe their cryptography, protocols, threat models and mitigations,
    highlighting pros and cons of each element. The seminar also offers a view about new and emerging
    cryptographic schemes in the identity space.
</p>
<h2>Organizers</h2>
<p>
    <b></b>
    <em>
        Andrea D'Intino (Forkbomb B.V., Netherlands)
        <br>
        Denis "Jaromil" Roio (Dyne Foundation, Netherlands)
    </em>
</p>
<h2>Program</h2>
<p>
    <i> September 27th, workshop session</i>
    <br>
    <i> Room D, 10:00 - 11:20</i>
</p>
<table class="orari" cellspacing="2" cellpadding="2" id="27afternoon">
    <tr bgcolor="lightblue" id="raipqc24">
        <th class="schedule" colspan="2">
            <font size="+1"><b>September 27th (morning) - Workshop Session</b></font>
        </th>
    </tr>
    <tr>
        <td class="schedule">
            10:00 <br> 10:20
        </td>
        <td>
            <i>
                <b>Andrea D'Intino</b>, Dyne Foundation (Netherlands)
            </i>
            <br>
            Overview of the current digital identity standards
            (<a target="_blank" href="https://drive.google.com/file/d/1X3aCqKITLHgdEI43Vprv1DAPG85MG3fq">slides</a>)
            <details>
                <summary>
                    Abstract
                </summary>
                In this talk we provide an overview of the ongoing digital identity efforts, focusing on the
                cryptography but including context about the political standpoints as well as the institutional and
                industry actors involved, int the EU and USA/Canada. We will provide a comparative analysis of the main
                cryptographic scheme used, along with communication protocols and the data formats for both digital
                identities and verifiable credentials. Some of the discussed subjects are:
                <ul>
                    <li>
                        Identity and credential formats: eIDAS 2.0 and EUDI-ARF and W3C-DID/VC with DHS, mobile driving
                        licenses and California Issuer of driving license
                    </li>
                    <li>
                        Communication protocols: OpenID4VCI and OpenID4VP
                    </li>
                    <li>
                        Overview of accepted signatures schemes in EUDI-ARF and W3C-VC
                    </li>
                    <li>
                        TEE and cryptographic devices
                    </li>
                </ul>
            </details>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            10:20 <br> 10:50
        </td>
        <td>
            <i>
                <b>Francesco Marino</b>, Poligrafico e Zecca dello Stato (Italy)
            </i>
            <br>
            Current status of the implementation of the Italian Wallet and Trust Framework Infrastructure
            
            (<a target="_blank" href="https://drive.google.com/file/d/1FZPK9CsyzEsWjnHF_V5kE9xtkPmYZ3gl">slides</a>)
            <details>
                <summary>
                    Abstract
                </summary>
                In our talks we will provide an in-depth analysis of the current status of the technical specification
                involved in the Wallet Architectures and Trust Infrastructure. The focus will then shift to the
                interoperability challenges at the European level, discussing the key requirements for a trust framework
                that ensures full interoperability. Finally, a concrete approach will be proposed to meet these
                requirements and guarantee seamless cross-border interactions between MS Wallet Solutions.
                Some of the discussed subjects are:
                <ul>
                    <li>
                        Introduction to Trust Models
                    </li>
                    <li>
                        Key Requirements and a proposed interoperability approach for a European Trust Framework
                    </li>
                </ul>
            </details>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            10:50 <br> 11:20
        </td>
        <td>
            <i>
                <b>Simone Onofri</b>, W3.org (USA)
            </i>
            <br>
            <i>
                <b>Denis Roio</b>, Dyne Foundation (Netherlands)
            </i>
            <br>
            Challenges and upcoming standards
            (<a target="_blank" href="https://drive.google.com/file/d/1WnHj793g9SPlIctsgm6LzjS4QTguWE2s">slides</a>)
            <details>
                <summary>
                    Abstract
                </summary>
                In our talks we will discuss the most actively discussed challenges of the existing digital identity
                standards, with extra focus on privacy. We will focus on the non-unlinkability issue of EUDI-ARF, on the
                revocation and on possible mitigations that are being discussed and experimented with.
                Some of the subjects that we discuss are:
                <ul>
                    <li>
                        Security, privacy and human rights considerations (Simone Onofri, Denis Roio)
                    </li>
                    <li>
                        Upcoming cryptography and formats (Denis Roio)
                    </li>
                    <li>
                        BBS+ Zero knowledge proofs
                    </li>
                    <li>
                        Post-quantum cryptography (experimental)
                    </li>
                    <li>
                        Overview of upcoming standards
                    </li>
                </ul>
            </details>
        </td>
    </tr>
</table>